export const TRANSLATE_API_URL = "https://api.translate.arml.trymagic.xyz/v1"